import React from 'react';
import * as hf from './_hf';
import * as ht from './_ht';
import * as icv from 'src/icv';
import * as ls from './_csLcl';
import * as cmLSG from './_cmLSG';

export const useGblz = (
  pName: 
    'dmn' | // dimension
    'lgg' | // language
    'clr' | // color
    'ctt' | // constant
    'scl' | // scale
    'user' | // user
    'stg' // setting
    , 
  paItl?: ht.dz,
) => { // !!!!! global 変数が node に対応しているか確認要 !!!!!

  if (!(global as ht.a).c) (global as ht.a).c = {};
  if (!(global as ht.a).c[pName]) (global as ht.a).c[pName] = paItl ?? {};

  const _clr = () => {
    (global as ht.a).c[pName] = {};
  };

  const _set = (_dz: ht.dz) => {
    hf.udtDz((global as ht.a).c[pName], _dz);
  };

  const _get = () => {
    return (global as ht.a).c[pName];
  };

  const _rlc = (_dz: ht.dz) => { // replace
    (global as ht.a).c[pName] = _dz;
  };

  const _rmvAsync = async () => {
    _clr();
    await cmLSG.rmvAsync(pName);
    //hf.l(`csGbl 41: rmvAsync ${pName}, ${hf.s(_get())}`);
    return _get();
  };

  const _saveAsync = async (_dz: ht.dz) => {
    _set(_dz);
    if (icv.srtz.gbl) hf.l(`cmCPT warning: set srt`)
    await cmLSG.setAsync(
      pName, 
      (global as ht.a).c[pName],
      icv.srtz.gbl
    )
    //hf.l(`csGbl 48: saveAsync ${pName}, ${hf.s(_get())}`);
    return _get();
  };

  const _loadAsync = async () => {
    if (!hf.f((global as ht.a).c[pName])) { // 空の場合のみ取得
      //hf.l(`csGbl 59: loadAsync ${pName}`);
      if (icv.srtz.gbl) hf.l(`cmCPT warning: set srt`)
      const _dz = await cmLSG.getAsync(
        pName, 
        icv.srtz.gbl
      );
      _set(_dz);
    }
    return _get();
  };

  _loadAsync();

  return {
    clr: _clr,
    rlc: _rlc,
    crt: (global as ht.a).c[pName],
    set: _set, // 既存項目は更新されないことに注意
    rmvAsync: _rmvAsync,
    saveAsync: _saveAsync,
    loadAsync: _loadAsync,
  }
};
/*
export const useUserzAsync = async () => {
  const _gUserz = useGblz('user');
  await _gUserz.loadAsync();
  return _gUserz;
};
*/
export const useUserz = () => useGblz('user');
export const useStgz = () => useGblz('stg');

/*
export const loadFstAsync = (pz?: {
  frcUdt?: () => void,
  atrAsync?: () => void,
}) => {
  const _gUserz = useGblz(`user`);
  React.useEffect(() => {
    //hf.l(`csGbl 76: ${hf.s(_gUserz.crt)}`)
    _gUserz.loadAsync()
    .then(( async () => {
      //hf.l(`csGbl 79: ${hf.s(_gUserz.crt)}`)
      if (pz?.atrAsync) await pz.atrAsync();
      if (pz?.frcUdt) pz.frcUdt();
    }));
  }, []);
};
*/

/*
export const GblRoot = (pz: {
  children: ht.a
}) => {
  const _frcUdt = ls.frcUdt();
  const _gUserz = useGblz(`user`);

  React.useEffect(() => {
    _gUserz.loadAsync()
    .then(( async () => {
      _frcUdt();
    }));
  }, []);

  return pz.children;

};
*/
